import { DEFAULT_NODE_COLOR, DEFAULT_SHAPE_FILL, DEFAULT_SHAPE_STROKE } from '../../../utils/constants';
import type { ShapeData } from './types';

export function makeDefault(): ShapeData {
  return {
    shapeKind: 'rectangle',
    fill: DEFAULT_SHAPE_FILL,
    stroke: DEFAULT_SHAPE_STROKE,
    strokeWidth: 2,
    strokeStyle: 'solid',
    cornerRadius: 0,
    fillOpacity: 1,
    strokeOpacity: 1,
    text: null,
    textAlign: 'center',
    verticalAlign: 'middle',
    fontSize: 14,
    bold: false,
    italic: false,
    underline: false,
    strikethrough: false,
    textColor: DEFAULT_NODE_COLOR,
  };
}
